module.exports = __webpack_public_path__ + "img/circle_orange.6497b2f3.png";